module.exports = __webpack_public_path__ + "img/hp11.0cba3b22.png";